import { useRef, useEffect } from 'react';
import { connect } from 'react-redux';

import {
  getSelectedCompareCards,
  getInitialCardsSet
} from 'src/universal/redux/compareCardsTray';
import {
  hasPznDataArrived,
  getPznSpecialOfferDtmInfo
} from 'src/universal/redux/pznData';
import { pageLevelBundledCmPznExt } from 'src/universal/utils/orchestraCmPznExtEvent';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';

const TrackPageLoadEvents = ({
  selectedCompareCards,
  initialCardsSet,
  pznDataArrived,
  pznSpecialOfferDtmInfo
}) => {
  const firedComparedCardsImpression = useRef(false);
  const firedSpecialOffersReceivedImpression = useRef(false);

  // Fires Compared Cards Impression Event
  useEffect(
    () => {
      if (!firedComparedCardsImpression.current && initialCardsSet) {
        firedComparedCardsImpression.current = true;
        const eventAsset = `cards_compared_${selectedCompareCards.join('_')}`;
        sendDTMCustomEvent({ eventAction: 'impression', eventAsset });
      }
    },
    [selectedCompareCards, initialCardsSet]
  );

  // Fires Special Offer Received Impression Event
  useEffect(
    () => {
      if (
        !firedSpecialOffersReceivedImpression.current &&
        pznSpecialOfferDtmInfo.needEvent
      ) {
        firedSpecialOffersReceivedImpression.current = true;
        sendDTMCustomEvent(pznSpecialOfferDtmInfo.dtmObj);
      }
    },
    [pznDataArrived]
  );

  // Fires bundled CM pzn Ext
  useEffect(
    () => {
      if (pznDataArrived) {
        setTimeout(() => {
          pageLevelBundledCmPznExt();
        }, 800);
      }
    },
    [pznDataArrived]
  );

  return null;
};

const mapStateToProps = state => ({
  selectedCompareCards: getSelectedCompareCards(state),
  initialCardsSet: getInitialCardsSet(state),
  pznDataArrived: hasPznDataArrived(state),
  pznSpecialOfferDtmInfo: getPznSpecialOfferDtmInfo(state)
});

export default connect(mapStateToProps)(TrackPageLoadEvents);
